module.exports = __webpack_public_path__ + "static/font-3e06a09121c2a9c7b5e5bcef9239f455.woff2";